import { useReducer } from 'react';

const initialState = {
  isNotFound: false,
  recipient: null,
  isLoading: true,
  isLoadingCanChat: true,
  canChat: false,
  chatBlockedReason: null,
  chatCheckFailed: false,
};

const reducer = (state, action) => {
  switch (action.type) {
    case 'loading': {
      return {
        isNotFound: false,
        recipient: null,
        isLoading: true,
        isLoadingCanChat: true,
        canChat: false,
        chatBlockedReason: null,
        chatCheckFailed: false,
      };
    }
    case 'success_recipient': {
      return {
        ...state,
        recipient: action.recipient,
        isLoading: false,
      };
    }
    case 'failure_recipient': {
      return {
        ...state,
        recipient: null,
        isLoading: false,
        isNotFound: true,
        canChat: false,
        isLoadingCanChat: false,
      };
    }
    case 'can_chat': {
      return {
        ...state,
        canChat: action.canChat,
        chatBlockedReason: action.reason ?? null,
        chatCheckFailed: Boolean(action.failed),
        isLoadingCanChat: false,
      };
    }
    default:
      throw Error('Unknown action.');
  }
};

const useDiscussion = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return { ...state, dispatch };
};

export default useDiscussion;
